import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#06110e",
  },
  mouseDragSurface: {
    cursor: "grab",
    userSelect: "none",
  } as never,
  strategyTabs: {
    position: "absolute",
    zIndex: 3000,
    top: 64,
    left: 10,
    right: 10,
    minHeight: 56,
    padding: 4,
    borderRadius: 14,
    flexDirection: "row",
    gap: 5,
    backgroundColor: "rgba(6,17,14,0.9)",
    borderWidth: 1,
    borderColor: "#285848",
  },
  strategyTab: {
    flex: 1,
    minWidth: 0,
    minHeight: 48,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: "transparent",
    backgroundColor: "#0b1b16",
  },
  strategyTabActive: {
    backgroundColor: "#159268",
    borderColor: "#28c99a",
  },
  strategyTabPublicActive: {
    backgroundColor: "#8f6d2c",
    borderColor: "#d7b65d",
  },
  strategyGroup: {
    color: "rgba(255,255,255,0.68)",
    fontSize: 10,
    lineHeight: 13,
    fontWeight: "600",
  },
  strategyLabel: {
    color: "white",
    fontSize: 14,
    lineHeight: 18,
    fontWeight: "800",
  },
  strategyTextActive: {
    color: "#080808",
  },
  emptyState: {
    alignItems: "center",
    justifyContent: "center",
    gap: 9,
    paddingHorizontal: 34,
    backgroundColor: "#06110e",
  },
  emptyStateTitle: {
    color: "white",
    fontSize: 17,
    fontWeight: "800",
  },
  emptyStateText: {
    maxWidth: 260,
    color: "rgba(255,255,255,0.62)",
    fontSize: 13,
    lineHeight: 20,
    textAlign: "center",
  },
  homeButton: {
    position: "absolute",
    zIndex: 2000,
    top: 16,
    right: 16,
    minHeight: 42,
    paddingHorizontal: 14,
    borderRadius: 22,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "rgba(6,17,14,0.88)",
    borderWidth: 1,
    borderColor: "#34745f",
  },
  homeButtonText: {
    color: "white",
    fontSize: 14,
    fontWeight: "700",
  },
});

export default styles;
